export const NotFoundPage = () => import(/* webpackChunkName: "not-found" */'@/components/404');
